import type { CodeBook } from "@king-ict/eupisi-ui/models";

import type { InstitutionLocation } from "../../../models/Institution";

export function institutionLocationsToCodeBook(
  institutionLocations: InstitutionLocation[],
): CodeBook[] {
  return institutionLocations.map((institutionLocation) => ({
    id: institutionLocation.id,
    name: institutionLocation.address,
  }));
}

